//import * as Keycloak from 'keycloak-js'
import * as React from 'react'

import { Loader } from '../Common/Loader'

export interface Props {
  clientId: string
  domain: string
  realm: string
  disableIframe?: boolean
  tokensSetCallback?: TokensSetCallback
  children: React.ReactNode
}

export interface State {
  authenticated: boolean
}

//export const KC_ID = 'KC'
export const JWT_ID = 'KC_JWT'
//export const JWT_REFRESH_TOKEN = 'KC_JWT_RT'
//export const KC_ID_TOKEN = 'KC_IDT'

export type TokensSetCallback = () => (void)

export class Authenticated extends React.Component<Props, State> {
  public kc: any
  // private REFRESH_MINUTES = 5

  constructor (props: Props) {
    super(props)

    /*const keycloakJs = {
      clientId: this.props.clientId,
      realm: this.props.realm,
      url: this.props.domain + '/auth/',
    }*/

    //this.kc = Keycloak(keycloakJs)

    this.state = {
      authenticated: false,
    }
  }

  public setSessionValues () {
    //sessionStorage.setItem(KC_ID, JSON.stringify(this.kc))
    //sessionStorage.setItem(JWT_ID, String(this.kc.token))
    //sessionStorage.setItem(JWT_REFRESH_TOKEN, String(this.kc.refreshToken))
    //sessionStorage.setItem(KC_ID_TOKEN, String(this.kc.idToken))

    // console.info('Persisted AT:', this.kc.token)
    // console.info('Persisted RT:', this.kc.refreshToken)

    if (undefined !== this.props.tokensSetCallback) {
      this.props.tokensSetCallback()
    }
  }

  public componentDidMount () {
    // See if we had prior tokens.
    //const at = sessionStorage.getItem(JWT_ID)
    //const rt = sessionStorage.getItem(JWT_REFRESH_TOKEN)
    //const idt = sessionStorage.getItem(KC_ID_TOKEN)
    //const init: Keycloak.KeycloakInitOptions = {}
    if (this.props.disableIframe) {
      //init.checkLoginIframe = false
    }

    // For now, disable this, as it's possible old session values have bad dates.
    // If we ever need to have front end that doesn't ping the SSO server each hard reload,
    // this would probably be the place to do it.
    //if (at && rt && idt) {
      // init.token = at
      // init.refreshToken = rt
      //// init.idToken = idt
      //init.onLoad = 'login-required'
    //} else {
      //init.onLoad = 'login-required'
    //}

    // For now, just always re-init
    /*this.kc.init(init)
      .success((authenticated: boolean) => {
        if (authenticated) {
          this.setSessionValues()
          this.setState({ authenticated: true })
        }
      })*/

    // Attempt to refresh the token every N minutes, if it isn't valid.
    setInterval(() => {
      // updateToken() is in seconds. Set to check if it expires within 1 hour.
      this.kc.updateToken(60 * 60).success((refreshed: boolean) => {
        if (refreshed) {
          // console.info('Successfully refreshed tokens...')
          this.setSessionValues()
        }

        // If the refresh failed, something broke, so reload the page.
        if (!refreshed) {
          console.warn('Failed to refresh token...')
        }
      })
    }, 1 * 1000 * 60 * 30) // 30 minutes
  }

  public render (): React.ReactNode {
    if (this.state.authenticated) {
      return this.props.children
    }

    return (
      <div className='min-h-screen flex flex-col justify-center items-center'>
        <div className='w-16 h-16'>
          <Loader />
        </div>
      </div>
    )
  }
}
